import React, { useState } from 'react'
import classes from './ReportCard.module.css'
import Card from '../../UI/Card/Card'
import { Col, Row } from 'react-bootstrap'
import { isEmpty } from '../../utils/custom_funtions'

const ReportCard = (props) => {
    const data = props.data;
    const [collapsed,setCollapsed] = useState(false)
  return (
    <div className={classes.card}>
    <div className={classes.innerCard}>
      <Row>
        <Col lg={9} md={12}>
          <p className={classes.time}>{data.report_date}</p>
          <Row>
            <Col lg={4} md={6} sm={12}>
              <p className="mb-1 mb-md-0">
                Division : <b>{data.sub_data[0].division}</b>
              </p>
            </Col>
            <Col lg={2} md={6} sm={12}>
              <p className="mb-1 mb-md-0">
                Class : <b>11th</b>
              </p>
            </Col>
            <Col lg={6} md={6} sm={12}>
              <p className="mb-1 mb-md-0">
                Batch : <b>{data.sub_data[0].batch}</b>
              </p>
            </Col>
            <Col lg={4} md={6} sm={12}>
              <p className="mb-1 mb-md-0">
                Subject : <b>{data.subject}</b>
              </p>
            </Col>
            <Col lg={4} md={6} sm={12}>
              <p className="mb-1 mb-md-0">
              Taken Class : <b>{data.taken_class}</b>
              </p>
            </Col>
          </Row>
        </Col>
        <Col lg={3} md={12}>
          <button className={classes.btn} onClick={() => setCollapsed(!collapsed)}>
            View Detailed Report
            {collapsed ?
            <i class="bx bx-chevron-up"></i>
            :
            <i class="bx bx-chevron-down"></i>
            } 
          </button>
        </Col>
      </Row>
      </div>
      {collapsed &&
      <div className='d-flex flex-wrap flex-column flex-md-row mt-1'>
      {data.sub_data.map((item) =>{
        return (
            <>
            <Col className={classes.bordered} lg={6} md={12}>
            <div className="d-flex justify-content-between gap-2">
                <p>Class Time</p>
                <b>{`${item.from_time} - ${item.to_time}`}</b>
            </div>
        </Col>
        <Col className={classes.bordered} lg={6} md={12}>
            <div className="d-flex justify-content-between gap-2">
                <p>Module Remark</p>
                <b>{isEmpty(item.module_sheet_disscussion_title) ? "-" : item.module_sheet_disscussion_title}</b>
            </div>
        </Col>
        <Col className={classes.bordered} lg={6} md={12}>
            <div className="d-flex justify-content-between gap-2">
                <p>Topic</p>
                <b>{item.topic}</b>
            </div>
        </Col>
        <Col className={classes.bordered} lg={6} md={12}>
            <div className="d-flex justify-content-between gap-2">
                <p>DPP Discussion</p>
                <b>{item.dpp_discussion == 0 ? "No" : "Yes"}</b>
            </div>
        </Col>
        <Col className={classes.bordered} lg={6} md={12}>
            <div className="d-flex justify-content-between gap-2">
                <p>Subtopic</p>
                <b>{item.select_sub_topic}</b>
            </div>
        </Col>
        <Col className={classes.bordered} lg={6} md={12}>
            <div className="d-flex justify-content-between gap-2">
                <p>DPP Remark</p>
                <b>{isEmpty(item.dpp_discussion_detail) ? "-" : item.dpp_discussion_detail }</b>
            </div>
        </Col>
        <Col className={classes.bordered} lg={6} md={12}>
            <div className="d-flex justify-content-between gap-2">
                <p>Subtopic Remark</p>
                <b>{item.select_sub_topic_title}</b>
            </div>
        </Col>
        <Col className={classes.bordered} lg={6} md={12}>
            <div className="d-flex justify-content-between gap-2">
                <p>Class Off</p>
                <b>{item.is_class_off == 0 ? "No" : "Yes"}</b>
            </div>
        </Col>
        <Col className={classes.bordered} lg={6} md={12}>
            <div className="d-flex justify-content-between gap-2">
                <p>Lecture No</p>
                <b>{item.topic_no_count}</b>
            </div>
        </Col>
        <Col className={classes.bordered} lg={6} md={12}>
            <div className="d-flex justify-content-between gap-2">
                <p>Class Off Remark</p>
                <b>{isEmpty(item.remark) ? "-" : item.remark}</b>
            </div>
        </Col>
        <Col className={classes.bordered} lg={6} md={12}>
            <div className="d-flex justify-content-between gap-2">
                <p>Module Discussion</p>
                <b>{item.module_sheet_discussion == 0 ? "No" : "yes"}</b>
            </div>
        </Col>
            </>
        )
      })}
      </div>
    }
    </div>
  );
}

export default ReportCard